import React, { useContext } from "react";
import { Link } from "react-router-dom";
import Input from "./Reusable/Input";
import Header from "./Reusable/Header";
import { AuthContext } from "../context/UserContext";
import { toast } from "react-toastify";
import { getThemeValue } from "../utilities/getThemeValue";

const Signup = () => {
    const { createUser, updateUser } = useContext(AuthContext);

    const handleSubmit = (event) => {
        // Get Form Data
        event.preventDefault();
        const form = event.target;
        const name = `${form.firstName.value} ${form.lastName.value}`;
        const img = form.img.value;
        const email = form.email.value;
        const password = form.password.value;
        const confirmPassword = form.confirmPassword.value;

        // Validations
        if (!name || !email || !password) {
            toast.error("Please fill all required fields", {
                theme: getThemeValue(),
            });
            return;
        }

        // Check Password
        if (password.length < 6) {
            toast.error("Password should be 6 characters or more", {
                theme: getThemeValue(),
            });
            return;
        }
        if (password !== confirmPassword) {
            toast.error("Passwords don't match", {
                theme: getThemeValue(),
            });
            return;
        }

        // Create New User
        createUser(email, password)
            .then(() => updateUser(name, img))
            .then(() => {
                form.reset();
                toast.success("Account Created Successfully!", {
                    theme: getThemeValue(),
                });
            })
            .catch((error) => {
                const errorMessages = {
                    "auth/email-already-in-use": "Email already registered",
                    "auth/invalid-email": "Invalid email address",
                    "auth/weak-password": "Password is too weak",
                };
                toast.error(errorMessages[error.code] || error.message, {
                    theme: getThemeValue(),
                });
            });
    };

    return (
        <>
            <Header title={"Create a new user"} route={"Signup"}></Header>
            <section className="form-container section-gap content-gap-y">
                <form onSubmit={handleSubmit} className="content-gap-y">
                    <div className="content-gap-y xs:flex-row justify-between">
                        <Input type={"text"} name={"firstName"} text={"First Name"} />
                        <Input type={"text"} name={"lastName"} text={"Last Name"} />
                    </div>
                    <Input type={"text"} name={"img"} text={"Image url"}></Input>
                    <Input type={"email"} name={"email"} text={"Email"} />
                    <Input type={"password"} name={"password"} text={"Password"} />
                    <Input type={"password"} name={"confirmPassword"} text={"Confirm Password"} />
                    <label className="label justify-start cursor-pointer">
                        <input type="checkbox" className="checkbox checkbox-primary" />
                        <p className="ml-2">
                            I agree to the
                            <a className="ml-2 underline" href="/">
                                Terms & Conditions
                            </a>
                        </p>
                    </label>
                    <input type={"submit"} value="Sign Up" className="btn btn-primary" />
                </form>
                <p className="text-center">
                    Already have an account?
                    <Link to="/signin" className="ml-1.5 font-bold uppercase underline">
                        Sign In Now
                    </Link>
                </p>
            </section>
        </>
    );
};

export default Signup;
